import React, { useEffect, createElement } from 'react';
export function TallyEmbed() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://link.peptidescienceinstitute.com/js/form_embed.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <div data-id="element-252">
      <iframe src="https://link.peptidescienceinstitute.com/widget/survey/rciRJDLJyMYvGJZNfF0b" style={{
      border: 'none',
      width: '100%',
      height: '600px'
    }} id="rciRJDLJyMYvGJZNfF0b" title="survey" data-id="element-253"></iframe>
    </div>;
}